import { render } from "./BorderBlockStartColor.vue?vue&type=template&id=4179b87e&scoped=true&ts=true"
import script from "./BorderBlockStartColor.vue?vue&type=script&lang=ts"
export * from "./BorderBlockStartColor.vue?vue&type=script&lang=ts"

import "./BorderBlockStartColor.vue?vue&type=style&index=0&id=4179b87e&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4179b87e"]])

export default __exports__